var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"users",staticStyle:{"margin":"auto"}},[_c('users-table',{on:{"transactionIdChanged":_vm.transactionIdChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }